export function getFeaturedCompanyListTitle(titleLocales, currentLocale) {
  const titleLocale = titleLocales.find((locale) => locale && locale.value && locale.locale === currentLocale)
  if (titleLocale) {
    return titleLocale.value
  }
  return ''
}
